import { render, staticRenderFns } from "./ConsejosAdicionales.vue?vue&type=template&id=22dc0423&scoped=true&"
import script from "./ConsejosAdicionales.vue?vue&type=script&lang=js&"
export * from "./ConsejosAdicionales.vue?vue&type=script&lang=js&"
import style0 from "./ConsejosAdicionales.vue?vue&type=style&index=0&id=22dc0423&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dc0423",
  null
  
)

export default component.exports